class VanillaTextNoise {
  constructor(selector = ".js-text-noise", options = {}) {
    this.selector = selector;

    this.width = options.width || 180;
    this.height = options.height || 180;
    this.frameCount = options.frameCount || 8;
    this.fps = options.fps || 12;
    this.animate = options.animate ?? true;

    this.elements = Array.from(document.querySelectorAll(this.selector));
    this.frames = [];
    this.frame = 0;
    this.loopTimeout = null;

    this.init();
  }

  init() {
    if (!this.elements.length) return;

    this.createFrames();
    this.applyFrame();

    if (this.animate) {
      this.loop();
    }
  }

  createFrames() {
    this.frames = [];

    for (let i = 0; i < this.frameCount; i++) {
      this.frames.push(this.createNoiseImage());
    }
  }

  createNoiseImage() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) return "none";

    canvas.width = this.width;
    canvas.height = this.height;

    const idata = ctx.createImageData(this.width, this.height);
    const buffer32 = new Uint32Array(idata.data.buffer);
    const len = buffer32.length;

    for (let i = 0; i < len; i++) {
      const random = Math.random();

      // 白い粒
      if (random < 0.045) {
        buffer32[i] = 0x55ffffff;
      }

      // 黒い粒
      else if (random < 0.075) {
        buffer32[i] = 0x33000000;
      }

      // 少し明るいグレー粒
      else if (random < 0.105) {
        buffer32[i] = 0x44dddddd;
      }
    }

    ctx.putImageData(idata, 0, 0);

    return `url("${canvas.toDataURL("image/png")}")`;
  }

  applyFrame() {
    const image = this.frames[this.frame];

    this.elements.forEach((element) => {
      element.style.setProperty("--text-noise-image", image);
    });
  }

  loop() {
    this.frame = this.frame >= this.frames.length - 1 ? 0 : this.frame + 1;

    this.applyFrame();

    this.loopTimeout = window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        this.loop();
      });
    }, 1000 / this.fps);
  }

  destroy() {
    if (this.loopTimeout) {
      window.clearTimeout(this.loopTimeout);
    }
  }
}

export default VanillaTextNoise;
